import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Glyph from './Glyph';
import AppStoreLink from './AppStoreLink';

/**
 * Sticky glass pill nav (handoff §1). On subpages the anchor links point
 * back at the home page sections; below 768px the link row disappears
 * entirely - logo + "Get the app" only, no hamburger.
 */
const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const prefix = isHomePage ? '' : '/';

  const links = [
    { href: `${prefix}#how`, label: 'How it works' },
    { href: `${prefix}#features`, label: 'Features' },
    { href: `${prefix}#screens`, label: 'Screens' },
    { href: `${prefix}#pricing`, label: 'Pricing' },
    { href: `${prefix}#faq`, label: 'FAQ' },
  ];

  return (
    <nav className="site-nav">
      <div className="site-nav-pill glass">
        <Link to="/" className="site-nav-brand" aria-label="Snapcipe home">
          <Glyph height={38} />
          <span>Snapcipe</span>
        </Link>
        <div className="site-nav-links">
          {links.map((link) => (
            <a key={link.label} href={link.href}>
              {link.label}
            </a>
          ))}
        </div>
        <AppStoreLink withGlyph={false}>Get the app</AppStoreLink>
      </div>
    </nav>
  );
};

export default Navbar;
